import type { ExternalServiceType } from "../api/externalServices";

declare global {
  interface Window {
    APIKEYS_SERVICES_AVAILABLE?: string;
  }
}

const SERVICE_TYPES: Record<string, ExternalServiceType> = {
  overpass_api: "overpass_api",
  qgis_plugins_proxy: "qgis_plugins_proxy",
};

export function getEnabledApiKeyServices(): ExternalServiceType[] {
  let configuredServices = window.APIKEYS_SERVICES_AVAILABLE;

  if (
    import.meta.env.DEV &&
    (!configuredServices || configuredServices.startsWith("{{"))
  ) {
    configuredServices = import.meta.env.VITE_APIKEYS_SERVICES_AVAILABLE;
  }

  if (!configuredServices || configuredServices.startsWith("{{")) return [];

  return Array.from(
    new Set(
      configuredServices
        .split(",")
        .map((service) => SERVICE_TYPES[service.trim().toLowerCase()])
        .filter((service): service is ExternalServiceType => !!service),
    ),
  );
}

export function getVisibleApiKeyServices(
  language: string,
  isRuCountry: boolean,
): ExternalServiceType[] {
  const canUseQgisPluginsProxy =
    language.startsWith("ru") && isRuCountry;

  return getEnabledApiKeyServices().filter(
    (service) =>
      service !== "qgis_plugins_proxy" || canUseQgisPluginsProxy,
  );
}
